export const validUser = { username: 'carlos', password: 'carlos724' };
export const invalidUser = { username: 'invalid', password: 'password' };
export const successfulTokenResponse = {
  token: '2|OIpovkstKxvEKhxd20oy36BCWwgyqYdoFJiwCgLX22edbec2',
  data: {
    userID: '6dKql',
    cellNumber: '123456789',
    email: 'demo@gmail.com',
    firstName: 'Demo',
    lastName: 'User',
    roles: {
      data: [{ id: '6dKqln2vD4RWV0Ee', name: 'Super Admin' }],
    },
    permissions: {
      data: [],
    },
    company: {
      data: {
        companyID: 'hashed-company-123',
        companyName: 'Company Name',
        emergencyContact: 'Emergency Contact',
        headOfficeAddress: 'Head Office Address',
        userLimit: 10,
        features: {
          data: [{ id: '1', name: 'feature' }],
        },
      },
    },
    groups: {
      data: [
        {
          groupID: '4155',
          name: 'Dev',
          description: 'testing',
          parent: null,
          hasChild: 0,
          dailyActivityReport: 0,
          allUsers: 0,
          stars: 1,
          features: {
            data: [],
          },
        },
        {
          groupID: '1516',
          name: 'QA',
          description: 'Testing',
          parent: null,
          hasChild: 0,
          dailyActivityReport: 0,
          allUsers: 0,
          stars: 0,
          features: {
            data: [
              {
                featureID: 'hashed-feature-29',
                name: 'Kiosk Mode',
              },
            ],
          },
        },
      ],
    },
  },
};
export const unsuccessfulTokenResponse = {
  message: 'An Exception occurred when trying to authenticate the User.',
  status: 422,
};
export const successfulLogoutResponse = {
  message: 'Token revoked successfully.',
};
